// Only use this for Webforms routes. For React routes, use routes.ts

export const routesWebforms = {
    /**
     * Replaces the current history entry's URL without reloading. Only for legacy Webforms-hosted
     * pages that lack a React Router context; use `history.replace` from React Router elsewhere.
     * A bare "?" resets the URL to the current path with no query string.
     */
    replaceWebformsHistoryState(url: string): void {
        const resolvedUrl =
            url === "?" ? location.protocol + "//" + location.host + location.pathname : url;
        // eslint-disable-next-line no-restricted-syntax
        (window as any).history.replaceState(null, "", resolvedUrl);
    },
};

export interface IDialogEventMessage<CloseCallbackData = any> {
    type: "closeModal" | "closeModalAndReload" | "setModalSize" | "reloadAfterClose";
    data?: CloseCallbackData;
}

// please talk to architecture before adding new classes/functions/interfaces
